import {
  LayoutDashboard, Users, FileText, CalendarDays, LayoutGrid,
  Receipt, Pill, FlaskConical, BarChart3, Package, Syringe, MessageSquare,
  Stethoscope, Clock, Globe2, Settings, Mic, Bot, HeartPulse, Star,
  Building2, Wallet, Sparkles, Megaphone, ListChecks, ClipboardList, Video, ShieldCheck, Users2, Microscope, Bell, Activity, RefreshCw,
  Siren, GraduationCap, Droplets, Briefcase,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export type MobileNavItem = {
  key: string;
  label: string;
  labelBn: string;
  path: string;
  icon: LucideIcon;
};

/** Primary bottom-tab destinations for the doctor app. */
export const DOCTOR_TABS: MobileNavItem[] = [
  { key: "home", label: "Home", labelBn: "হোম", path: "/app", icon: LayoutDashboard },
  { key: "rx", label: "Rx", labelBn: "প্রেসক্রিপশন", path: "/prescriptions/new", icon: FileText },
  { key: "patients", label: "Patients", labelBn: "রোগী", path: "/patients", icon: Users },
  { key: "inbox", label: "Inbox", labelBn: "বার্তা", path: "/inbox", icon: MessageSquare },
  { key: "more", label: "More", labelBn: "আরও", path: "#more", icon: LayoutGrid },

];

/** Everything else, grouped, surfaced through the More sheet. */
export const MOBILE_MODULE_GROUPS: { title: string; items: MobileNavItem[] }[] = [
  {
    title: "Clinical",
    items: [
      { key: "scribe", label: "AI Scribe", labelBn: "স্ক্রাইব", path: "/scribe", icon: Mic },
      { key: "voice-memos", label: "Voice Memos", labelBn: "ভয়েস মেমো", path: "/voice-memos", icon: Mic },
      { key: "teleconsultation", label: "Telemedicine", labelBn: "টেলিমেডিসিন", path: "/teleconsultation", icon: Video },
      { key: "lab-orders", label: "Lab Orders", labelBn: "ল্যাব", path: "/lab-orders", icon: FlaskConical },
      { key: "digital-serial", label: "Digital Serial", labelBn: "ডিজিটাল সিরিয়াল", path: "/digital-serial", icon: ListChecks },
      { key: "emergency-triage", label: "Emergency Triage", labelBn: "জরুরী ট্রায়াজ", path: "/emergency-triage", icon: Siren },
      { key: "family-health", label: "Family Health", labelBn: "পরিবার স্বাস্থ্য", path: "/family-health", icon: HeartPulse },
      { key: "lab-referrals", label: "Lab Referrals", labelBn: "ল্যাব রেফারেল", path: "/lab-referrals", icon: FlaskConical },
      { key: "vaccinations", label: "Vaccines", labelBn: "ভ্যাকসিন", path: "/vaccinations", icon: Syringe },
      { key: "referrals", label: "Referrals", labelBn: "রেফারেল", path: "/referrals", icon: Stethoscope },
      { key: "care-gaps", label: "Care Gaps", labelBn: "কেয়ার গ্যাপ", path: "/care-gaps", icon: HeartPulse },
      { key: "remote-monitoring", label: "Remote Monitoring", labelBn: "রিমোট মনিটরিং", path: "/remote-monitoring", icon: Activity },
      { key: "guidelines", label: "Guidelines", labelBn: "গাইডলাইন", path: "/clinical-guidelines", icon: ClipboardList },
      { key: "blood-bank", label: "Blood Bank", labelBn: "রক্তের মজুদ", path: "/blood-bank", icon: Droplets },
      { key: "cme", label: "CME Tracker", labelBn: "সিএমই ও গবেষণা", path: "/cme", icon: GraduationCap },
      { key: "research", label: "Research", labelBn: "গবেষণা", path: "/research", icon: Microscope },
    ],
  },
  {
    title: "Practice",
    items: [
      { key: "practice-desk", label: "Practice Desk", labelBn: "প্র্যাকটিস ডেস্ক", path: "/practice-desk", icon: Briefcase },
      { key: "community-health", label: "Community Health", labelBn: "কমিউনিটি হেলথ", path: "/community-health", icon: Megaphone },
      { key: "daily-rounds", label: "Daily Rounds", labelBn: "আজকের দিনলিপি", path: "/daily-rounds", icon: Clock },
      { key: "schedule", label: "Schedule", labelBn: "সূচি", path: "/appointments", icon: CalendarDays },
      { key: "billing", label: "Billing", labelBn: "বিলিং", path: "/billing", icon: Receipt },

      { key: "daily-income", label: "Daily Income", labelBn: "হিসাব খাতা", path: "/daily-income", icon: Wallet },
      { key: "financial-planner", label: "Financial Planner", labelBn: "কর ও আর্থিক পরিকল্পনা", path: "/financial-planner", icon: Wallet },
      { key: "financial-operations", label: "Financial Ops", labelBn: "ফাইন্যান্সিয়াল অপারেশনস", path: "/financial-operations", icon: Wallet },
      { key: "financial-sync", label: "Financial Sync", labelBn: "আর্থিক সিঙ্ক", path: "/financial-sync", icon: Wallet },
      { key: "medico-legal", label: "Medico-Legal Vault", labelBn: "মেডিকো-লিগ্যাল ভল্ট", path: "/medico-legal", icon: ClipboardList },
      { key: "chambers", label: "Chambers", labelBn: "চেম্বার", path: "/chambers", icon: Building2 },
      { key: "tasks", label: "Tasks", labelBn: "টাস্ক", path: "/tasks", icon: ListChecks },
      { key: "smart-scheduling", label: "Smart Scheduling", labelBn: "স্মার্ট শিডিউলিং", path: "/smart-scheduling", icon: Sparkles },
      { key: "queue", label: "Queue", labelBn: "সিরিয়াল", path: "/display-control", icon: Clock },
      { key: "waiting-room", label: "Waiting Room", labelBn: "ওয়েটিং রুম", path: "/waiting-room", icon: Clock },
      { key: "queue-history", label: "Queue History", labelBn: "সারির ইতিহাস", path: "/queue-history", icon: Clock },
      { key: "patient-feedback", label: "Reviews & Ratings", labelBn: "মতামত ও রেটিং", path: "/patient-feedback", icon: Star },

      { key: "staff", label: "Staff", labelBn: "স্টাফ", path: "/staff", icon: Users2 },
      { key: "staff-portal", label: "Staff Portal", labelBn: "স্টাফ পোর্টাল", path: "/staff-portal", icon: HeartPulse },
      { key: "medicines", label: "Medicines", labelBn: "ঔষধ", path: "/medicines", icon: Pill },
      { key: "inventory", label: "Inventory", labelBn: "ইনভেন্টরি", path: "/inventory", icon: Package },
    ],
  },
  {
    title: "Growth",
    items: [
      { key: "analytics", label: "Analytics", labelBn: "অ্যানালিটিক্স", path: "/analytics", icon: BarChart3 },
      { key: "engagement", label: "Engagement Hub", labelBn: "এনগেজমেন্ট হাব", path: "/engagement", icon: Megaphone },
      { key: "communications", label: "Messages", labelBn: "মেসেজ", path: "/communications", icon: MessageSquare },
      { key: "ai-agent", label: "AI Agent", labelBn: "এআই এজেন্ট", path: "/ai-agent", icon: Bot },
      { key: "reviews-inbox", label: "Reviews", labelBn: "রিভিউ", path: "/reviews-inbox", icon: Star },
      { key: "website", label: "Website", labelBn: "ওয়েবসাইট", path: "/website", icon: Globe2 },
    ],
  },
  {
    title: "Account",
    items: [
      { key: "offline-sync", label: "Offline Sync", labelBn: "অফলাইন সিঙ্ক", path: "/offline-sync", icon: RefreshCw },
      { key: "notifications", label: "Notifications", labelBn: "নোটিফিকেশন", path: "/notifications", icon: Bell },
      { key: "settings", label: "Settings", labelBn: "সেটিংস", path: "/settings", icon: Settings },
      { key: "account-security", label: "Security", labelBn: "নিরাপত্তা", path: "/account-security", icon: ShieldCheck },
      { key: "audit-log", label: "Audit Log", labelBn: "অডিট লগ", path: "/audit-log", icon: ShieldCheck },
      { key: "access-report", label: "Access Report", labelBn: "অ্যাক্সেস রিপোর্ট", path: "/access-report", icon: ShieldCheck },
    ],
  },

];

const ALL_ITEMS = [...DOCTOR_TABS, ...MOBILE_MODULE_GROUPS.flatMap((g) => g.items)];

export function titleForPath(pathname: string): string {
  const exact = ALL_ITEMS.find((i) => i.path === pathname);
  if (exact) return exact.label;
  const partial = ALL_ITEMS.filter((i) => i.path !== "/app" && pathname.startsWith(i.path))
    .sort((a, b) => b.path.length - a.path.length)[0];
  return partial?.label ?? "DoctorsX";
}
